import { useRef } from 'react';

// Chrome ignores the input's `autocomplete` attribute on Autocomplete inputs and instead
// remembers typed values keyed off the input `id`. MUI's fallback id (`useId`) is deterministic
// across reloads, so Chrome matches it every session and shows history. Generating a truly
// random id per mount removes that stable key. Only applied when the caller opts into autofill
// suppression and hasn't supplied their own id.
export default function useAutofillSafeId(inputAutoComplete?: string, id?: string) {
  const autofillSafeIdRef = useRef<string>();
  if (inputAutoComplete && !id && !autofillSafeIdRef.current) {
    autofillSafeIdRef.current = `fa-autofill-${Math.random().toString(36).slice(2)}`;
  }
  return autofillSafeIdRef.current;
}
